<div class="container">
  <div class="row head">
    <div class="col-12 col-md-6">
      <span class="title" i18n="checklist|@@checklist">Checklist</span>
      <svg id="checkmark-c" class="checkmark" width="16px" height="12px" viewBox="0 0 8 6" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title i18n="checklist|@@saved">Enregistré</title>
        <desc>Created with Sketch.</desc>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="UI-Rapport-+-Slideshow-Current" transform="translate(-149.000000, -213.000000)" fill-rule="nonzero">
            <g id="Group" transform="translate(145.000000, 166.000000)">
              <g id="Group-9" transform="translate(0.000000, 35.000000)">
                <g id="Group-10">
                  <path d="M10.8678734,12.1874017 L6.6639304,16.3885707 L5.13212661,14.8577776 C4.87000385,14.6047781 4.45334661,14.6083963 4.19566301,14.8659099 C3.93797941,15.1234234 3.93435877,15.5398058 4.1875254,15.8017555 L6.1916298,17.8045375 C6.45249729,18.0651542 6.87536351,18.0651542 7.136231,17.8045375 L11.8124746,13.1313796 C12.0656412,12.8694298 12.0620206,12.4530475 11.804337,12.1955339 C11.5466534,11.9380203 11.1299961,11.9344021 10.8678734,12.1874017 Z" id="Path"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
    <div class="col-12 mt-3" *ngIf="checklistDisplay && checklistDisplay.length > 0">
      <table class="table">
        <tbody *ngIf="checklistDisplay">
          <tr *ngFor="let checklist of  checklistDisplay">
            <th class="checklistdisplay" scope="row">
              {{checklist.display}}
            </th>
            <th scope="row  ">
              <app-generic-toggle (sendData)="saveChange(checklist.id, $event)" [value]="checklist.value"></app-generic-toggle>
            </th>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/element/report-check-list/report-check-list.component.html